var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    width: 16,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Composite Path",
    fillRule: "evenodd",
    className: "s0",
    d: "m14.1 0c0.9 0 1.9 1 1.9 1.9v13.2c-0.1 1-1.1 1.9-1.8 1.9h-12.4c-1-0.1-1.8-1.2-1.8-1.9v-13.2c0-0.9 1-1.9 1.8-1.9zm-0.6 1.9c0.3 0 0.7 0.4 0.7 0.7v1.9c0 0.2-0.3 0.7-0.6 0.7h-2.1c-0.2 0-0.5-0.4-0.5-0.6v-2.1c0-0.2 0.3-0.6 0.6-0.6zm-2.3 6.6c0 1.9-1.5 3.2-3.2 3.2-1 0-2.4-0.5-3-2.2-0.1-0.2-0.2-0.6-0.2-0.7v-0.7c0.3-1.9 1.9-2.9 3.2-2.9 1.8 0 3.2 1.4 3.2 3.3zm-8-1.3q-0.2 0.7-0.2 1.4c0 3 2.4 5.2 5 5.2 2.7 0 5-2.3 5-5.2 0-0.3-0.1-1.1-0.2-1.4h1.4v7.3c0 0.1-0.3 0.5-0.5 0.5h-11.4c-0.2 0-0.5-0.3-0.5-0.6v-7.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.28ec500a9c9f9df0d4d9d6ea0432a788.svg";
export { ForwardRef as ReactComponent };